import styled from 'styled-components';

export const FadeInContainer = styled.div`
  display: flex;
  max-width: 100%;
  height: 100vh;
  flex-direction: column;
  flex-wrap: nowrap;
  @media (min-width: 760px) {
    width: 420px;
    margin: 0 auto;
  }
  animation: fadeInOpacity 250ms ease-in-out;
  opacity: 1;
  @keyframes fadeInOpacity {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
export const Container = styled.div`
  display: flex;
  max-width: 100%;
  height: 100vh;
  flex-direction: column;
  flex-wrap: nowrap;
  @media (min-width: 760px) {
    width: 420px;
    margin: 0 auto;
  }
`;

export const HeaderContainer = styled.div``;

export const Header = styled.div`
  display: flex;
  max-width: 100%;
  background: ${(props) => props.theme.palette.primary.main};
  color: ${(props) => props.theme.palette.primary.contrastText};
  font-family: 'Rubik';
  text-align: center;
  padding: 20px;
  margin: 0px 20px;
  justify-content: center;
  border-bottom: 1px solid ${(props) => props.theme.palette.lightTransparency};
`;

export const BackgroundHeader = styled.div`
  width: 100%;
  content: ' ';
  background: ${(props) => props.theme.palette.primary.main};
  height: ${(props) => props.BackgroundHeight || 'unset'};
  margin-bottom: -${(props) => props.BackgroundHeight || 'unset'};
`;

export const InfosHeader = styled.div`
  color: ${(props) => props.theme.palette.primary.contrastText};
  font-size: 16px;
  text-align: center;
  margin: 30px 19px 0px;
  display: flex;
  flex-direction: column;
  max-width: 100%;
`;

export const TextHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 100%;
  margin: 0px 25px;
`;

export const BoxData = styled.div`
  font-size: 16px;
  display: flex;
  flex-flow: wrap;
  background: ${(props) => props.theme.palette.secondary.main};
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  margin: 15px auto;
  padding: 10px 60px;
  @media (max-width: 330px) {
    padding: 10px 40px;
  }
`;

export const SpanData = styled.div`
  font-family: 'RubikLight';
  font-size: 13px;
  font-weight: 400;
  margin: 0px 5px;
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 375px;
  justify-content: flex-start;
  margin: 0px auto;
  box-sizing: border-box;
  > * {
    margin: 12px;
  }
  max-width: 314px;
  @media (max-width: 330px) {
    max-width: 264px;
  }
`;

export const PdfContainer = styled.div`
  background: gray;
  display: flex;
  max-width: 100vw;
  height: auto;
  min-height: 1500px;
  flex-direction: column;
  flex-wrap: nowrap;
  -webkit-overflow-scrolling: touch;
  overflow-x: scroll;
  margin-bottom: 200px;
  canvas {
    padding-top: 50px;
    padding-bottom: 100px;
    margin: 0 auto;
  }
`;

export const PdfNotFoundContainer = styled.div`
  display: flex;
  max-width: 100%;
  height: 100vh;
  flex-direction: column;
  flex-wrap: nowrap;
  padding-top: 120px;
`;

export const NotFoundReaderPdfTitle = styled.div`
  font-size: 16px;
  color: ${(props) => props.theme.palette.primary.main};
  text-align: center;
  margin: 20px;
`;

export const NotFoundReaderPdfButton = styled.button`
  display: flex;
  flex-wrap: wrap;
  position: fixed;
  bottom: 20px;
  max-width: 100%;
  height: 50px;
  border: 1px solid ${(props) => props.theme.palette.primary.main};
  border-radius: 8px;
  width: 279px;
  text-align: center;
  font-weight: 600;
  color: ${(props) => props.theme.palette.primary.main};
  justify-content: center;
  align-content: center;
  align-self: center;
  background: ${(props) => props.theme.palette.primary.contrastText};

  a {
    color: ${(props) => props.theme.palette.primary.main};
  }
`;
